/**
 * Системні сторінки робочого простору → ключ підпису для контексту ШІ-асистента (прототип v4: «Простір › Сторінка»; перший сегмент шляху
 * (ADR-028), порожній — Головна; `area` — огляд напряму `/<група>`). «Моя робота» — це Головна, як у прототипі.
 */
export const aiPageLabels: Record<string, string> = {
  '': 'nav.home', work: 'nav.home', inbox: 'inboxPage.title', search: 'nav.search', modules: 'nav.modules', recent: 'homeNav.recent',
  favourites: 'homeNav.favourites', bi: 'biPage.crumb', members: 'membersPage.crumb', profile: 'profilePage.title',
  admin: 'sysPages.admin', customize: 'sysPages.customize', area: 'areaPage.menu',
};
